module.exports = __webpack_public_path__ + "img/logo_gobierno_aragon.3eb6107f.png";